module.exports = __webpack_public_path__ + "img/美港电讯@2x.abfd4b40.png";